<!--
 * @Author: Merlin
 * @Date: 2025-01-22 18:33:17
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-02 16:45:07
 * @Description: 
因为当前游戏在收到输赢结果后可以“立即” 呈现
经查验，原版游戏也是“立即” 显示扣款的， 
基于以上，现在关闭以下方法，于 2025.03.10 14:49:53 星期一 
.showDateInQueue()
.queueForward()
-->

<template>
    <!-- 取到了 randomSeed 说明在历史窗口中，此时到禁用点击事件  -->
    <div class="flex gap-2 relative flex-col-reverse select-none board-container"
        :class="{'pointer-events-none': round?.['randomSeed']}"
    >
        <div
            class="w-full gap-2 inline-flex relative"
            v-for="(muti, rowIndex) in mutipls"
            :key="rowIndex"
            :class="handleSetFocus(rowIndex + 1, round)"
        >
            <!-- 左侧赔率表 start -->
            <div
                v-if="!disabledMutipler"
                class="w-[71px] text-[11px] text-[#ffffff80] h-full rounded min-w-[70px] font-bold flex items-center justify-center item-coefficient"
                :class="[
                    isEnableRow(rowIndex)
                        ? 'bg-[#3a1f85]'
                        : round.step > rowIndex
                        ? 'bg-[#c92eff]'
                        : 'bg-[#4b2d9f]',
                    round.step >= rowIndex && 'text-white',
                ]"
            >
                x{{ getFixed(muti as number) }}
            </div>
            <!-- 左侧赔率表 end -->
            <!-- ↓ 用户点击区 ↓  -->
            <div
                v-for="(v, boardIndex) in 5"
                :key="boardIndex"
                class="h-full overflow-hidden relative w-full rounded m-auto flex justify-center items-center item-col"
                :class="[
                    setCardBg(rowIndex, boardIndex, round),
                    isInPrediction(rowIndex, boardIndex) === 'devil' && 'lose',
                    (isEnableRow(rowIndex) || isInSavePredictions(rowIndex, boardIndex)) &&
                        'cursor-pointer',
                    rowIndex === 9 &&
                        round.status === 'cashout' &&
                        isInPrediction(rowIndex, boardIndex) === 'dude' &&
                        'last-win',
                ]"
                @click="() => onAutoRowClick(rowIndex, boardIndex)"
                aaaaa_v-longpress="()=>fnLongPress({rowIndex, boardIndex})"
            >
                <img
                    v-if="!isOpen(rowIndex)"
                    :src="HideCardImg"
                    class="w-7 h-[25px]"
                    :class="[
                        (isEnableRow(rowIndex) || isInSavePredictions(rowIndex, boardIndex)) &&
                            animateEnabled &&
                            'animate-spin',
                    ]"
                />
                <div class="z-[2]" v-else>
                    <img
                        v-if="isInPrediction(rowIndex, boardIndex) === 'dude'"
                        :src="LineBgImg"
                        class="absolute left-1/2 top-1/2 -translate-x-1/2 z-[-1] -translate-y-1/2 transform"
                        :class="[
                            isInPrediction(rowIndex, boardIndex) === 'dude' &&
                                animateEnabled &&
                                'lines-roll',
                        ]"
                    />
                    <img
                        v-if="!isInFields(rowIndex, boardIndex)"
                        :src="DudeImg"
                        class="w-7 h-[25px] !z-[2]"
                        :class="[animateEnabled && 'pop']"
                    />
                    <img
                        v-if="isInFields(rowIndex, boardIndex)"
                        :src="DevilImg"
                        class="w-7 h-[25px] !z-[2] scale-100"
                        :class="[animateEnabled && 'pop']"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// assets
import HideCardImg from '~/pages/casino/towerGame/img/hide-card.webp';
import DevilImg from '~/pages/casino/towerGame/img/devil.webp';
import DudeImg from '@/assets/BetCorgiLogo/Site-logo.svg';
import LineBgImg from '~/pages/casino/towerGame/img/line-bg.webp';
import { BetType, GameStatus, type RoundStatus } from '~/pages/casino/towerGame/data';
// socket
import { useGameSocket } from '~/socket/game';
import { useJoinStateStore } from '~/stores/cansino/joinState';

import useTranslation from '~/i18n/useTransLation';

const t = useTranslation();
const { EMIT_TOWER_BET } = useGameSocket();
const joinStateStore = useJoinStateStore();

const props = defineProps({
    currentMutiplier: {
        type: Number,
        required: true,
    },
    isAuto: {
        type: Boolean,
        required: true,
    },
    round: {
        type: Object as PropType<RoundStatus>,
        required: true,
    },
    fields: {
        type: Array<Array<Number>>,
        required: true,
        default: ()=>[],
    },
    savedPredictions: {
        type: Array as PropType<number[]>,
        required: true,
    },
    isSubmiting: {
        type: Boolean,
        required: true,
    },
    predictionSending: {
        type: Boolean,
        required: true,
    },
    sounds: {
        type: [Object, null],
        default: () => ({}),
        required: false,
    },
    animateEnabled: {
        type: Boolean,
        required: true,
    },
    disabledMutipler: {
        type: Boolean,
        default: false,
    },
    coefficients: {
        type: Object as PropType<any>,
        default: () => ({})
    },
    mutiConfig: {
        type: Object,
        required: true,
    },
    multiInfoShowDuration: {
        type: Number,
        required: true,
    },
});

const emit = defineEmits([
    'update:predictionSending',
    'update:savedPredictions',
    'update:fields',
    'update:round',
    'update:isOpenResult',
    'reset',
]);

/**
 * 点击选择一个格子
 * 方法为叫 “Auto" 但手动自动模式都使用此方法 
 * 左下角是坐标起点, x0, y0, 最顶部是第9行（人类序第10行）
 * @param rowIndex 行下标
 * @param boardIndex 列下标
 */
const onAutoRowClick = async (rowIndex: number, boardIndex: number) => {
    console.log('clicked on, row:column', rowIndex, boardIndex); 
    props.sounds?.oAudio.simpleClick.toPlay();
    const iStep = props.round.step;
    console.log('savedPredictions', deepCopy(props.savedPredictions)); 
    // ↓ 追加取消功能：只有自动模式的 “最后” 的选项能取消  
    const toCancel = (
        props.isAuto
        && rowIndex == iStep-1
        && boardIndex == props.savedPredictions.at(-1)
    );
    if (toCancel){
        const savedPredictions = deepCopy(props.savedPredictions);
        savedPredictions.pop();
        console.log('自动模式取消选中', deepCopy(savedPredictions)); 
        emit('update:round', {
            ...deepCopy(props.round),
            step: Math.max(0, iStep - 1), // 回退一步
            level: Math.max(0, props.round.level - 1), // 回退一步
        });
        emit('update:savedPredictions', savedPredictions);
        return;
    }
    // iStep === -1 未点击下注按钮开启下注
    // rowIndex !== iStep 当前点击的行需跟可进行下注的行对应
    if (iStep >= 10 || iStep === -1 || rowIndex !== iStep) {
        return console.log('驳回点击 01');
    }

    if (props.isAuto) {
        let changValue = 0;
        if (rowIndex >= iStep) {
            changValue = 1;
        } else {
            changValue = -1;
        }

        if (changValue === -1) {
            emit('update:savedPredictions', props.savedPredictions.slice(0, -1));
        } else {
            emit('update:savedPredictions', [...props.savedPredictions, boardIndex]);
        }
        emit('update:round', {
            ...props.round,
            step: iStep + changValue,
            level: props.round.level + changValue,
        });
    } else {
        if (['lose', 'win'].includes(props.round.status)) {
            return;
        }
        if (props.predictionSending) {
            return console.log('禁止连点 ☢️');
        }
        emit('update:predictionSending', true); // 上锁，以防止连点和突然结算
        // if (import.meta.env.DEV_MODE && Math.random() < 0.3){ 
        //     boardIndex = -1; 
        // }
        const res = (await EMIT_TOWER_BET({
            prediction: boardIndex,
            isFast: false,
            type: BetType.HandsStart,
            frontID: new Date().getTime(),
        })) as any;
        emit('update:predictionSending', false); // 解锁
        if (!res || res?.code) {
            showNegativeNotify(res?.error);
            return;
        }
        const step = ++props.round.step;
        emit('update:fields', res.fields);
        emit('update:round', {
            ...props.round,
            ...res,
            step,
            status: !res.win || res.status === 'lose' ? 'lose' : (res.status || 'cashout'),
            prediction: [...props.round.prediction, boardIndex],
        });
        if (!res.win) {
            // joinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
            joinStateStore.gameRunning = false;
        }
        const sFileds = JSON.stringify(props.fields);
        // 成功登顶后自动提现
        if (res.fields?.length === 10 && res.status === 'cashout') {
            console.log('tower 登顶大胜'); 
            joinStateStore.gameRunning = false;
            // 显示赢分动画并播放音效
            emit('update:isOpenResult', true);
            props.sounds?.oAudio.win.toPlay();
            await Sleep(props.coefficients.insertDelay);
            // joinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
            await Sleep(props.multiInfoShowDuration); 
            emit('update:isOpenResult', false);
            // ↓ 在此需要查询 fields 是否变化了，没变化才继续执行清空  
            if (sFileds == JSON.stringify(props.fields)){
                emit('reset');
            }else{
                console.log('放弃清空舞台');  // 因为可能开了新局 
            }
        }
    }
};

const mutipls = computed(() => {
    return Object.values(
        props.mutiConfig[props.currentMutiplier]
    );
});

/**
 * 当前行是否可操作
 * @param levelIndex 行下标
 */
const isEnableRow = (levelIndex) => {
    if (props.isAuto) {
        if (props.round.prediction.length - 1 === props.round.level) return false;
        if ([GameStatus.PLAY, GameStatus.LOSE].includes(props.round.status)) return false;
        return props.round.step === levelIndex;
    }
    return props.round.step === levelIndex;
};
/**
 * 设置行边框颜色
 * @param levelIndex 行下标
 * @param round
 */
const handleSetFocus = (levelIndex, round) => {
    let borderClass = '';
    if (!props.isAuto) {
        const { status, step } = round;
        // 失败时，行边框添加至失败行
        if (['lose'].includes(status) && step === levelIndex) {
            borderClass = 'focus';
            // 下注、提现状态时，行边框添加至上一待选择行
        } else if (['cashout', 'play'].includes(status) && step === levelIndex - 1) {
            borderClass = 'focus';
            // 成功登顶时，行边框添加至成功行
        } else if (step === levelIndex && step === 10 && status === 'cashout') {
            borderClass = 'focus focus-win';
        }
    } else {
        const { prediction, step } = round;
        let fieldsArr = [];
        prediction &&
            Object.values(prediction).forEach((item, index) => {
                fieldsArr.push(isInFields(index, item));
            });
        // 如果已选中的集合中有命中devil的格子
        const currDevilIndex = fieldsArr.findIndex((ele) => ele);
        // 下注失败后的样式
        if (currDevilIndex > -1 && levelIndex === currDevilIndex + 1) {
            borderClass = 'focus';
            // 下注成功且未登顶的样式
        } else if (
            currDevilIndex === -1 &&
            levelIndex === Object.keys(prediction).length &&
            levelIndex < 10
        ) {
            borderClass = 'focus';
            // 自动模式下注前，选择格子时的样式
        } else if (!fieldsArr.length && levelIndex === step + 1) {
            borderClass = 'focus';
            // 成功登顶后的样式
        } else if (
            fieldsArr.length &&
            currDevilIndex === -1 &&
            levelIndex === step &&
            levelIndex === 10
        ) {
            borderClass = 'focus focus-win';
        }
    }
    return borderClass;
};
/**
 * 是否明牌
 * @param rowIndex 行下标
 */
const isOpen = (rowIndex) => {
    // console.log('rowIndex', rowIndex)
    if (props.fields && props.fields.length === 10) return true;
    const currentyIndex = rowIndex;
    if (props.isAuto) {
        // check fields was include the prediction
        const field = props.round.prediction[currentyIndex];

        return field !== undefined;
    }
    // console.log('props.round', props.round)
    if (props.round.prediction.length === mutipls.value.length) return true;
    return rowIndex < props.round.step || props.round.status === 'lose';
};
/**
 * 判断自己的选择是否在接口返回的fields中(是否命中devil)
 * @param levelIndex 行下标
 * @param boardIndex 列下标
 */
const isInFields = (levelIndex, boardIndex) => {
    if (!props.fields || props.fields.length === 0) return false;
    const field = props.fields[levelIndex];

    return Object.values(field).includes(boardIndex);
};
const isInSavePredictions = (levelIndex, boardIndex) => {
    if (props.isAuto && props.savedPredictions) {
        const savedPrediction = props.savedPredictions[levelIndex];

        return savedPrediction === boardIndex;
    }
};
/**
 * 判断是填充dude还是devil
 * @param levelIndex 行下标
 * @param boardIndex 列下标
 */
const isInPrediction = (levelIndex, boardIndex) => {
    if (props.round.prediction[levelIndex] === boardIndex && !isInFields(levelIndex, boardIndex))
        return 'dude';
    else if (
        props.round.prediction[levelIndex] === boardIndex &&
        isInFields(levelIndex, boardIndex)
    )
        return 'devil';
};
/**
 * 设置背景颜色(在原代码上修改，待优化)
 * @param rowIndex 行下标
 * @param boardIndex 列下标
 * @param round
 */
const setCardBg = (rowIndex, boardIndex, round) => {
    // 手动模式
    if (
        !props.isAuto &&
        (isEnableRow(rowIndex) ||
            isInPrediction(rowIndex, boardIndex) === 'dude' ||
            isInSavePredictions(rowIndex, boardIndex))
    ) {
        if (
            (!['lose'].includes(round.status) && round.step >= rowIndex) ||
            (!round.win && round.step !== rowIndex && round.prediction[rowIndex] === boardIndex)
        ) {
            return 'bg-[#c92eff]';
        }

        return 'bg-[#4c47be]';
    }
    // 自动模式 & 投注详情
    if (
        props.isAuto &&
        (isEnableRow(rowIndex) ||
            isInPrediction(rowIndex, boardIndex) === 'dude' ||
            isInSavePredictions(rowIndex, boardIndex))
    ) {
        if (
        !props.disabledMutipler && (
                !['lose'].includes(round.status) &&
                round.step === rowIndex) ||
            (!round.win && round.step !== rowIndex && round.prediction[rowIndex] === boardIndex)
        ) {
            return 'bg-[#c92eff]';
        }
        if (!['lose'].includes(round.status) && round.step > rowIndex) {
            return 'selected-bg';
        }
        return 'bg-[#4c47be]';
    }
    return 'bg-[#4c47be]';
};

// 长按事件，先停用，使用点击来选中和取消选中（自动模式时）
// const fnLongPress = (params)=>{
//     if (!props.isAuto) {
//         return console.log('不理会手动模式的长按');
//     }
//     const {rowIndex, boardIndex} = params;
//     console.log('长按：', rowIndex, boardIndex); 
// }

// const startEvent = ['mousedown', 'touchstart'];
// const endEvent = ['mouseup', 'mouseleave', 'touchend', 'touchcancel'];

// const vLongpress = {
//     mounted: (el, binding) => {
//         let timer;
//         const duration = binding.arg || 500;
//         const callback = binding.value;
//         const startHandler = () => {
//             timer = setTimeout(() => {
//                 callback();
//             }, duration);
//         };
//         const endHandler = () => {
//             clearTimeout(timer);
//         };
//         startEvent.forEach(event => {
//             el.addEventListener(event, startHandler);
//         });
//         endEvent.forEach(event => {
//             el.addEventListener(event, endHandler);
//         });
//         // 保存事件处理函数，方便在 unmounted 中移除
//         el._longPressHandlers = {
//             startHandler,
//             endHandler,
//         };
//     },
//     unmounted: (el) => {
//         const handlers = el._longPressHandlers;
//         if (!handlers) return; 
//         startEvent.forEach(event => {
//             console.log('取消事件 A：', event);  
//             el.removeEventListener(event, handlers.startHandler);
//         });
//         endEvent.forEach(event => {
//             console.log('取消事件 B：', event); 
//             el.removeEventListener(event, handlers.endHandler);
//         });
//         delete el._longPressHandlers;
//     }
// };

</script>

<style lang="scss" scoped>
.board-container {
    @media (max-width: 576px) {
        gap: 6px;
    }
}
.item-coefficient {
    height: 32px;
    margin-right: 8px;
    @media (max-width: 576px) {
        height: 35px;
        margin-right: 4px;
        min-width: 70px;
    }
}
.item-col {
    height: 32px;
    @media (max-width: 576px) {
        height: 35px;
    }
}
.lose {
    background: radial-gradient(47.5% 95% at 50% 50%, #ff8ea9 0, #da384e);
}
.win {
    background: radial-gradient(40% 80% at 50% 50%, #ffbce4 0, #c92eff);
}
.last-win {
    background: radial-gradient(50.83% 101.67% at 50% 50%, #ffe608 0, #ffb636) !important;
}
.focus::before {
    border: 2px solid #4c47be;
    border-radius: 7px;
    bottom: -4px;
    content: '';
    left: -4px;
    opacity: 1;
    position: absolute;
    right: -4px;
    top: -4px;
    transition: opacity 1s;
}
.focus-win::before {
    border: 2px solid #ffb835;
    opacity: 1;
}
.lines-roll {
    animation: lines-roll-animation 8s linear infinite;
}

.pop {
    animation: popAnimate 1s ease-in-out forwards;
}
.selected-bg {
    background: radial-gradient(40% 80% at 50% 50%, #ffbce4 0, #c92eff);
}
@keyframes lines-roll-animation {
    100% {
        transform: translate(-50%, -50%) rotate(1turn);
    }
}

@keyframes popAnimate {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}
</style>
